module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rtop-dialog-wrap"
  }, [_c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.topBtnClick()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("会员可以免费选择任意黄金亮点，使用后将在简历中展现所选择的特长优势。")]), _vm._v(" "), _c('div', {
    staticClass: "resume-chose clear"
  }, [_c('p', {
    staticClass: "tit inline fl"
  }, [_vm._v("选择简历：")]), _vm._v(" "), _c('ul', {
    staticClass: "resume-list fl"
  }, _vm._l((_vm.resumeList), function(item) {
    return _c('li', {
      key: item.confuseResumeId,
      staticClass: "resume",
      class: {
        checked: _vm.resumeChose === item.confuseResumeId
      },
      on: {
        "click": function($event) {
          return _vm.choseResume(item.confuseResumeId)
        }
      }
    }, [_vm._v(_vm._s(item.resumeName))])
  }), 0)]), _vm._v(" "), _c('p', {
    staticClass: "tit inline fl"
  }, [_vm._v("黄金亮点：")]), _vm._v(" "), _c('ul', {
    staticClass: "days-list fl"
  }, _vm._l((_vm.lightList), function(item) {
    return _c('li', {
      key: item.type,
      staticClass: "day",
      class: {
        checked: item.type === _vm.lightChose
      },
      on: {
        "click": function($event) {
          return _vm.choseLight(item.type)
        }
      }
    }, [_vm._v(_vm._s(item.desc))])
  }), 0)]), _vm._v(" "), (_vm.showWarn) ? _c('cvip-alert', {
    attrs: {
      "buttonTxt": "我知道了",
      "widthnew": "450px",
      "heightnew": "200px",
      "marginnew": "-100px auto"
    },
    on: {
      "on-hide": _vm.onHide
    }
  }, [_c('span', {
    staticClass: "alert-icon icon-warn"
  }), _vm._v(" "), _c('span', [_vm._v("请选择简历或者黄金亮点！")])]) : _vm._e(), _vm._v(" "), _c('cvip-toast', {
    attrs: {
      "text": _vm.toastText
    },
    model: {
      value: (_vm.toastShow),
      callback: function($$v) {
        _vm.toastShow = $$v
      },
      expression: "toastShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49f8ec53"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/dialog/GoldLightDialog.vue
// module id = BSwo
// module chunks = 1